const stats = [
  { value: "2,500+", label: "Active Restaurants", icon: "ri-store-2-line" },
  { value: "50M+", label: "Orders Processed", icon: "ri-shopping-bag-3-line" },
  { value: "15min", label: "Average Setup Time", icon: "ri-timer-line" },
  { value: "35%", label: "Revenue Increase", icon: "ri-line-chart-line" },
];

export default function Stats() {
  return (
    <section className="py-16 md:py-24 bg-primary-500 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-64 h-64 rounded-full bg-background-50"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 rounded-full bg-background-50"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-80 h-80 rounded-full bg-accent-500"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-4">
            Trusted by Restaurants Everywhere
          </h2>
          <p className="text-sm md:text-base text-background-200 max-w-xl mx-auto">
            Join thousands of restaurant owners who have transformed their
            operations with EzyDinePro.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="text-center p-6 rounded-lg bg-background-50/10 backdrop-blur-sm border border-background-50/20"
            >
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-background-50/20 text-background-50 mb-4">
                <i className={`${stat.icon} text-xl`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-heading font-extrabold text-background-50 mb-1">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-background-300">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}